import { render } from "./Search.vue?vue&type=template&id=e1f6f7d2"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"
script.render = render

export default script